// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__h3OgC","bg":"modal_bg__odNFB","wrapper":"modal_wrapper__p8-X+","close":"modal_close__A8fzD"};